<template>
  <div
    id="app"
    :class="`${Browsers.browserClassname()}`"
  >
    <MuiModal />
    <div
      v-if="isLoaded"
    >
      <RouterView />
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import Cookie from 'js-cookie';

import { MuiModal } from '@ubeeqo/motion-ui';
import { Browsers } from '@/utils';
import * as UserAccount from '@/store/modules/App/UserAccount/UserAccountModule';

export default {
  name: 'App',
  components: {
    MuiModal,
  },
  computed: {
    Browsers: () => Browsers,
    ...mapState(UserAccount.FULL_NAMESPACE, {
      isLoaded: state => state.STATUS.LOADED,
    }),
  },
  async mounted() {
    const isUserLoggedIn = Cookie.get('authData') || localStorage.getItem('authData');
    if (isUserLoggedIn) {
      await this.getUserAccount();
    }
  },
  methods: {
    ...mapActions(UserAccount.FULL_NAMESPACE, [
      'getUserAccount',
    ]),
  },
};
</script>
